import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@medprompt/shared';
import '@medprompt/shared/src/common/CommonStyles.css';
import SystmOneBridgeGate from './systmone/SystmOneBridgeGate';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loading state if auth check is in progress
  if (loading) {
    return <div className="loading">Loading</div>;
  }

  // Redirect to login if not authenticated
  if (!user) {
    // Save the location they were trying to access for redirect after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <SystmOneBridgeGate>{children}</SystmOneBridgeGate>;
};

export default ProtectedRoute; 